import { Injectable } from '@angular/core';
import { EventService } from "./event.service";
import { Observable, Subject } from "rxjs";
@Injectable()
export class VoteUpdateService {

  constructor(private eventService: EventService) { }

  eventVoteCheck(count, newCount): Observable<any>{
    console.log(count, newCount);
    let status = new Subject();
    if(newCount > count){
      status.next(true);
       return status;
    }else{
      status.next(false);
       return status;
    }
    //return status;
  }

}
